import { useEffect, useState } from 'react';

// The value as it stood `delay` ms ago, unless it changed again since: typing settles before
// anything expensive (a request) happens. The first value is returned at once.
export default function useDebouncedValue<T>(value: T, delay: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return settled;
}
